import travlr from 'images/travlr.jpg';
import digit from 'images/digit.png';
import blog from 'images/blog.png';
import neutron from 'images/neutron.jpg';
import portfolio from 'images/portfolio.png';
import website from 'images/webiste.png';
import procol from 'images/procol.png';

// image can be any size. just make sure it is close to a 1:1 ratio - a square.

export default [
  {
    title: 'Software Developer at Procol',
    duration: 'July 2020- Ongoing',
    description:
      'Working on implementing new features in the Agribid dashboard as a front-end developer',
    skills: ['React', 'JavaScript', 'Redux', 'AntD', 'HTML5', 'CSS', 'NodeJS'],
    image: procol,
    links: {
      github: '',
      preview: '',
      shouldHideGit: true,
      shouldHidePrev: true,
    },
  },
  {
    title: 'Software Developer(Internship) at eGoverments Foundation',
    duration: 'Aug 2019- June 2020',
    description:
      'Collaborated in a cross-functional Platform team by developing highly scalable REST APIs based on the Micro-services architecture using Java Spring-Boot, JDBC, PostgreSQL, Kafka. Worked on Implementing SMS-OTPNotification service and using Kafka to integrate it with other services, Modifying the PaymentGateway service to be more agile and useless resources on the back-end,Testing and fixing SQL Injection vulnerabilities in the Report Service, Automating E2E Testing for the E-pass and MCS service using cypress framework and upgrading a lot of internal services as well.',
    skills: [
      'Microservices',
      'Java Spring Boot Framework',
      'React',
      'Cypress',
      'Restful Web Services',
      'PostgreSQL',
    ],
    image: travlr,
    links: {
      github: '',
      preview: '',
      shouldHideGit: true,
      shouldHidePrev: true,
    },
  },
  {
    title: 'Portfolio',
    duration: '',
    description:
      'This page! Responsive website built with ReactJS. The site content is passed in as JSON data, auto-generating components for easy maintenance.',
    skills: ['HTML5', 'CSS', 'Sass', 'JavaScript', 'ReactJS'],
    image: portfolio,
    links: {
      github: 'https://github.com/dhavalsingh/dhavalsingh.github.io',
      preview: 'https://dhavalsingh.github.io/',
      shouldHideGit: false,
      shouldHidePrev: false,
    },
  },
  {
    title: 'Personal Website',
    duration: '',
    description:
      'I created my personal responsive webiste with space inavaders game integrated.',
    skills: ['HTML5', 'CSS', 'JavaScript', 'Jquery'],
    image: website,
    links: {
      github: 'https://github.com/dhavalsingh/personalsite',
      preview: 'https://dhavalsingh.github.io/personalsite/',
      shouldHideGit: false,
      shouldHidePrev: false,
    },
  },
  {
    title:
      'Use of computational Physics in determining Neutron stars as potential gravitational wave emitters',
    duration: 'Aug 2018 - April 2019',
    description:
      'RNS Code was used to solve the Tolman-Oppenheimer-Volkoff (TOV) equations and further used to construct models of non-rotating, relativistic, compact stars usingtabulated equations of state which are supplied by the user.',
    skills: ['C++', 'Python', 'Matlab'],
    image: neutron,
    links: {
      github: '',
      preview: '',
      shouldHideGit: true,
      shouldHidePrev: true,
    },
  },
  {
    title: 'Handshake Vigilante',
    duration: ' ',
    description: 'My Blog based on Movie and Tv shows',
    skills: ['Wordpress'],
    image: blog,
    links: {
      github: 'https://handshakevigilante.wordpress.com/',
      preview: 'https://handshakevigilante.wordpress.com/',
      shouldHideGit: true,
      shouldHidePrev: false,
    },
  },
];



// WEBPACK FOOTER //
// ./src/content/projects.js